import Service from '@ember/service';
import Validator from 'validator';
import { stripTags } from "../utils/misc";
const {isURL, isEmail} = Validator;

export default Service.extend({

  /////////////////////////////////
  // linkifyText
  //
  // * Takes any raw text that begins with http, https, or ftp and
  // * returns an <a> tag with the appopriate href value
  /////////////////////////////////

  linkifyText(textNode) {

    return textNode.replace(/\S+/gu, function(word) {

      let punctuationMatch = word.match(/(.*)(!|\?|\.)$/);
      let wordToCheck;
      let punctuation;

      if(punctuationMatch !== null) {
        wordToCheck = punctuationMatch[1];
        punctuation = punctuationMatch[2];
      } else {
        wordToCheck = word;
        punctuation = '';
      }

      if(isURL(wordToCheck) && !isEmail(wordToCheck)) {
        const href = wordToCheck.match(/^(?:http|https|ftp):\/\//) !== null ? wordToCheck : `http://${wordToCheck}`;
        const tag =  `<a href="/out?link=${encodeURIComponent(href)}" target="_blank" rel="nofollow noopener noreferrer">${wordToCheck}</a>${punctuation}`;
        return stripTags(tag, ['a']);
      }

      return word;
    });
  }

});
